import { motion } from "framer-motion";
import { EASE_EXPO, VIEWPORT } from "@/lib/motion";
import { TextReveal } from "@/components/ui/TextReveal";

const chapters = [
  {
    n: "01",
    title: "Fresh, small batches",
    body:
      "Everything is baked to order in small quantities. Nothing sits in a display case for days.",
  },
  {
    n: "02",
    title: "Ingredients I'd feed my own kids",
    body:
      "No artificial preservatives. Real fresh ingredients, unbleached flour, pure jaggery options, and honest chocolate.",
  },
  {
    n: "03",
    title: "Custom orders welcomed",
    body:
      "100% Pure Vegetarian options, sugar free options - just ask a day before.",
  },
  {
    n: "04",
    title: "Local pickup or delivery",
    body:
      "Home pickup from our kitchen in Karad, Pune (Prior Order).",
  },
];

const Row = ({ ch, i }) => (
  <motion.div
    data-testid={`manifesto-row-${i}`}
    initial={{ opacity: 0, y: 16 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={VIEWPORT}
    transition={{ duration: 0.35, delay: i * 0.04, ease: EASE_EXPO }}
    className="group grid grid-cols-12 gap-3 md:gap-6 py-4 sm:py-5 md:py-6 border-t border-[#3B2818]/15 last:border-b items-center"
  >
    <div className="col-span-3 md:col-span-2">
      <span className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-[#C06A22] italic block leading-none">
        {ch.n}
      </span>
    </div>
    <div className="col-span-9 md:col-span-4">
      <h3 className="font-serif text-lg sm:text-xl md:text-2xl lg:text-3xl leading-tight text-[#3B2818] transition-transform duration-200 ease-out-expo group-hover:translate-x-1">
        {ch.title}
      </h3>
    </div>
    <div className="col-span-12 md:col-span-6 md:pl-4">
      <p className="text-xs sm:text-sm md:text-[15px] leading-relaxed text-[#6B5343]">
        {ch.body}
      </p>
    </div>
  </motion.div>
);

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-12 sm:py-16 md:py-20 bg-[#FAF6F0]"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12">
        <div className="mb-6 sm:mb-8 md:mb-10 flex flex-col md:flex-row md:items-end justify-between gap-3 md:gap-6">
          <div>
            <span className="text-[11px] uppercase tracking-[0.28em] text-[#C06A22]">
              Why families order
            </span>
            <TextReveal className="font-serif text-[28px] sm:text-[36px] md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-2 text-[#3B2818] max-w-2xl">
              A short list of things we don't cut corners on.
            </TextReveal>
          </div>
          <p className="max-w-xs text-xs sm:text-sm text-[#6B5343]">
            No fluff, no fake stats. Just how we bake, everyday.
          </p>
        </div>

        <div>
          {chapters.map((c, i) => (
            <Row key={c.n} ch={c} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
